<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-character-modal-infomation-modal']"
   :additionalZIndex="3"
   :isOpen="isOpenModal"
   :position="{top: .1}"
   :isFreez="true"
   :couldOverlaySwipeClose="false"
   contentTransitionName="trans-content"

   @afterEnterContent="handleAfterEnterContent"
   @afteredAfterEnterContent="handleAfterdEnterContent"
   @closeOverlayModal="handleCloseOverlay"
  >
    <PaWideModalBox
     ref="wideModalComponent"
     :itemImageName="textInfomation.itemSlug"
     :confirmButtonText="textInfomation.buttonText"
     :shoudDisplayCancelButton="false"
     :lineMessage="textInfomation.lineMessage"
     :isSubmitLoading="textInfomation.submitLoading"
     :isDisabledSubmit="textInfomation.submitDisabled"
     :countUpCircleText="textInfomation.countUpText"
     :isEnterdContent="isEnterdContent"
     @handleSubmit="handleClickSubmitButton"
     @handleCancel="handleClickCancelButton"
    >
      <template v-slot:title>{{textInfomation.title}}</template>
      <template v-slot:description>{{textInfomation.description}}</template>
      <template v-if="(textInfomation.caption !== null)" v-slot:caption>{{textInfomation.caption}}</template>
    </PaWideModalBox>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PaWideModalBox from '@/components/Parts/PAWideModalBox/PAWideModalBox.vue'

import {GetUserMeta}  from '@/graphql/queries/User.graphql'

import {GetModalAlertInfomations} from '@/graphql/queries/Character.graphql'

import {UpdateCharacterModalInfomation} from '@/graphql/mutations/Character.graphql'

export default {
  components : {
    PaOverlayModal,
    PaWideModalBox
  },

  data(){
    return {
      modalInfomation     : null,
      modalInfomationMeta : null,

      unreadInfomationId  : null,
      isOpenModal         : false,

      textInfomation  : {
        itemSlug        : '',
        buttonText      : '',
        lineMessage     : null,
        submitLoading   : false,
        submitDisabled  : false,
        
        title           : '',
        description     : '',
        caption         : '',
        countUpText     : null
      },

      textTemplates     : {
        getItem   : {
          title       : 'アイテム付与の御知らせ',
          description : 'アイテム「[[itemName]]」が[[quanty]]個付与されました。',
          caption     : '※最新アイテムが付与されたタイミングで表示致しておりますが、異世界時空間乱れの影響で稀に重複して御知らせを行う場合が御座います。御了承くださいませ。',
          buttonText  : '確認',
          lineMessage : null
        },
        
        getPoint        : {
          title       : 'ポイント付与の御知らせ',
          description : 'チャプターポイントが[[point]]付与されました。',
          caption     : '※最新ポイントが付与されたタイミングで表示致しておりますが、異世界時空間乱れの影響で稀に重複して御知らせを行う場合が御座います。御了承くださいませ。',
          buttonText  : '確認',
          lineMessage : null
        }
      },

      couldOpenModal    : {
        point : false,
        item  : false
      },

      userMeta : null,

      isEnterdContent : false,
    };
  },

  apollo : {
    modalAlertInfomations : {
      query: GetModalAlertInfomations
    },

    userMetaList: {
      query: GetUserMeta
    }
  },

  computed : {
    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    },
  },

  watch : {
    isMountedLoginedViewPage(){
      this.checkCouldOpenModal();
    },

    unreadInfomationId(){
      this.checkCouldOpenModal();
    },

    modalAlertInfomations : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data.length == 0){
          this.modalInfomation = null;
        }else{
          this.modalInfomation = this.modalAlertInfomations[0];
        }
      },
      deep: true
    },

    modalInfomation : {
      handler(data){
        if(typeof data === 'undefined' || data === null){
          this.modalInfomationMeta = null;
          this.unreadInfomationId  = null;
        }else{
          this.modalInfomationMeta = JSON.parse(data.encordedMeta);
          this.unreadInfomationId  = data.id;
        }
      },
      deep: true
    },

    userMetaList : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.userMeta = JSON.parse(data.data);
      },
      deep: true
    },

    userMeta    : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(typeof data['modalNotifications.isEnableCharacterLevelUpModal'] !== 'undefined'){
          this.couldOpenModal.point = data['modalNotifications.isEnableCharacterLevelUpModal'];
        }
        
        if(typeof data['modalNotifications.isEnableGetItemModal'] !== 'undefined'){
          this.couldOpenModal.item = data['modalNotifications.isEnableGetItemModal'];
        }

        this.checkCouldOpenModal();
      },
      deep: true
    },
  },

  methods : {
    handleAfterEnterContent(){
      const actualHeight = window.innerHeight - ((window.innerHeight * .1) * 2);

      const boxHeight = this.$refs.wideModalComponent.$refs.wideModalBox.offsetHeight;
      
      if(boxHeight > actualHeight){
        this.$refs.wideModalComponent.$refs.wideModalBox.style.height = actualHeight + 'px';
      }
    },
    
    handleAfterdEnterContent(){
      this.isEnterdContent = true;
    },

    mutateAndSetText(){
      this.textInfomation.itemSlug = this.modalInfomationMeta.itemSlug;

      const mutationFields = ['buttonText', 'lineMessage', 'title', 'description', 'caption'];

      for(let i = 0; i < mutationFields.length; i++){
        if(this.textTemplates[this.modalInfomationMeta.modalInfomationType][mutationFields[i]] !== null){
          this.textInfomation[mutationFields[i]] = this.$options.filters.templateReplacer(
            this.textTemplates[this.modalInfomationMeta.modalInfomationType][mutationFields[i]],
            this.modalInfomationMeta
          );
        }
      }

      if(this.modalInfomationMeta.modalInfomationType === 'getPoint'){
        this.textInfomation.countUpText = this.modalInfomationMeta.point;
      }else{
        this.textInfomation.countUpText = null;
      }
    },

    checkCouldOpenModal(){
      let couldOpenModal = false;

      if(this.unreadInfomationId !== null && this.isMountedLoginedViewPage === true && this.userMeta !== null){
        this.mutateAndSetText();

        switch(this.modalInfomationMeta.modalInfomationType){
          case 'getPoint':
            couldOpenModal = this.couldOpenModal.point;
          break;

          case 'getItem':
            couldOpenModal = this.couldOpenModal.item;
          break;
        }
      }

      this.isOpenModal = couldOpenModal;
    },

    handleCloseOverlay(){
      this.closeModal();
    },

    handleClickSubmitButton(){
      this.isOpenModal = false;

      if(this.unreadInfomationId !== null){
        this.executeMarkReadModalInfoamtion(this.unreadInfomationId);
      }
    },

    handleClickCancelButton(){
      this.isOpenModal = false;

      if(this.unreadInfomationId !== null){
        this.executeMarkReadModalInfoamtion(this.unreadInfomationId);
      }
    },

    async closeModal(){
      this.isEnterdContent = false;
      this.$apollo.queries.modalAlertInfomations.refetch();
    },

    executeMarkReadModalInfoamtion(modalInfomationId){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UpdateCharacterModalInfomation,
          variables : {
            character_modal_infomation_id : modalInfomationId
          },
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    }
  }
}
</script>

<style lang="scss">
.pa-character-modal-infomation-modal{
  .pa-wide-modal-box{
    overflow-y: scroll;
  }
}
</style>